import { toast } from 'sonner';

export const GLOBAL_ERROR_EVENT = 'mp:global-error';

let toastErrorPatched = false;

function normalizeErrorMessage(input) {
  if (typeof input === 'string') {
    const trimmed = input.trim();
    return trimmed || 'Something went wrong. Please try again.';
  }
  if (input && typeof input.message === 'string') {
    const trimmed = input.message.trim();
    return trimmed || 'Something went wrong. Please try again.';
  }
  return 'Something went wrong. Please try again.';
}

export function showGlobalError(message, options = {}) {
  if (typeof window === 'undefined') return;
  const detail = {
    message: normalizeErrorMessage(message),
    duration: Number(options.duration) > 0 ? Number(options.duration) : 5000,
  };
  window.dispatchEvent(new CustomEvent(GLOBAL_ERROR_EVENT, { detail }));
}

export function installToastErrorRedirect() {
  if (toastErrorPatched || !toast || typeof toast.error !== 'function') return;
  toastErrorPatched = true;
  toast.error = (message, options = {}) => {
    showGlobalError(message, options);
    return undefined;
  };
}
